<template>
    <div class="review-workbench-page public_box">
        <div class="review-workbench-page__hero">
            <div>
                <h2>核验工作台</h2>
                <p>统一承载重复图片核验、相似图片核验及后续新增的风险核验能力，支持业务快速切换与扩展。</p>
            </div>
            <el-tag type="success" size="mini">统一入口</el-tag>
        </div>

        <div class="review-workbench-page__grid">
            <review-workbench-entry-card
                title="重复图片核验"
                summary="confirmed_duplicate_hash_record"
                description="集中核验重复图片结果，判断候选是否值得进入深挖风险页面继续使用。"
                status-text="已上线"
                status-type="success"
                @enter="navigateTo('/calculatorTool/duplicateReview')"
            />
            <review-workbench-entry-card
                title="相似图片核验"
                summary="similar_image_review_record"
                description="集中核验高相似候选图，支持按一级分类筛选并完成人工确认有效、排除或待定。"
                status-text="已上线"
                status-type="warning"
                @enter="navigateTo('/calculatorTool/similarImageReview')"
            />
            <review-workbench-entry-card
                title="更多风险核验"
                summary="扩展预留"
                description="后续新增的不同风险案件核验能力将统一接入此工作台，保持入口一致、切换一致。"
                status-text="待扩展"
                status-type="info"
                @enter="handleComingSoon"
            />
        </div>
    </div>
</template>

<script>
import ReviewWorkbenchEntryCard from "@/components/medical/ReviewWorkbenchEntryCard.vue";

export default {
    name: "ReviewWorkbenchPage",
    components: {
        ReviewWorkbenchEntryCard,
    },
    methods: {
        navigateTo(path) {
            this.$router.push({ path });
        },
        handleComingSoon() {
            this.$message.info("扩展核验能力入口预留中");
        },
    },
};
</script>

<style scoped>
.review-workbench-page {
    padding: 24px;
}

.review-workbench-page__hero {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 24px;
}

.review-workbench-page__hero h2 {
    margin: 0;
    color: #1f2d3d;
}

.review-workbench-page__hero p {
    margin: 8px 0 0;
    max-width: 720px;
    color: #5e6b80;
    line-height: 1.7;
}

.review-workbench-page__grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 18px;
}

@media (max-width: 1100px) {
    .review-workbench-page__grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 768px) {
    .review-workbench-page {
        padding: 16px;
    }

    .review-workbench-page__hero {
        flex-direction: column;
    }
}
</style>
